(function () {
  function init(root) {
    if (!root || root.dataset.vatpanRefInit === '1') return;
    root.dataset.vatpanRefInit = '1';

    var tabs = root.querySelectorAll('.vatpan-ref-tab');
    var cards = root.querySelectorAll('.vatpan-ref-card');
    var allLabel = root.dataset.filterAll || 'All Industries';

    function applyFilter(filter) {
      cards.forEach(function (card) {
        var isAll = filter === allLabel;
        var matches = card.dataset.category === filter;
        card.classList.toggle('dimmed', !isAll && !matches);
        card.classList.toggle('category-active', !isAll && matches);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('mousedown', function (e) {
        e.preventDefault();
      });
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var x = window.scrollX;
        var y = window.scrollY;
        tabs.forEach(function (item) {
          item.classList.remove('active');
        });
        tab.classList.add('active');
        applyFilter(tab.dataset.filter || allLabel);
        window.scrollTo(x, y);
      });
    });

    root.querySelectorAll('.vatpan-ref-card img.vatpan-ref-logo-img').forEach(function (img) {
      img.addEventListener('error', function () {
        var card = img.closest('.vatpan-ref-card');
        if (img.dataset.customLogo === 'true') {
          if (card) card.classList.add('logo-error');
          return;
        }
        var favicon = img.dataset.favicon;
        var ddg = img.dataset.ddg;
        if (favicon && img.src !== favicon) {
          img.src = favicon;
          img.removeAttribute('data-favicon');
          return;
        }
        if (ddg && img.src !== ddg) {
          img.src = ddg;
          img.removeAttribute('data-ddg');
          return;
        }
        if (card) card.classList.add('logo-error');
      });

      img.addEventListener('load', function () {
        var card = img.closest('.vatpan-ref-card');
        if (card) card.classList.remove('logo-error');
      });
    });

    applyFilter(allLabel);
  }

  document.querySelectorAll('[data-vatpan-rack-references]').forEach(init);

  document.addEventListener('shopify:section:load', function (ev) {
    var r =
      ev.target &&
      ev.target.querySelector &&
      ev.target.querySelector('[data-vatpan-rack-references]');
    if (r) init(r);
  });
})();
